/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeTransactionInfoRequest
 */
export interface RuntimeTransactionInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof RuntimeTransactionInfoRequest
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof RuntimeTransactionInfoRequest
     */
    round: number;
    /**
     * 
     * @type {string}
     * @memberof RuntimeTransactionInfoRequest
     */
    hash: string;
}

export function RuntimeTransactionInfoRequestFromJSON(json: any): RuntimeTransactionInfoRequest {
    return RuntimeTransactionInfoRequestFromJSONTyped(json, false);
}

export function RuntimeTransactionInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeTransactionInfoRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'round': json['round'],
        'hash': json['hash'],
    };
}

export function RuntimeTransactionInfoRequestToJSON(value?: RuntimeTransactionInfoRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'round': value.round,
        'hash': value.hash,
    };
}


